import React from 'react'

const HeaderTitle = (props) => {
    const {title,width} = props;
  return (
    <h1 className={`${width > 768 ? 'text-2xl' : 'text-sm'} font-semibold tracking-tight text-customForeColor dark:text-customWhite mx-3`}>
      {title}
    </h1>
  )
}

export default HeaderTitle
